import React from 'react'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'
import cx from 'classnames'
import { range } from 'libraries/lodash'

export const StoriesSkeleton = () => (
  <Grid container spacing={2} className='bg-page-background'>
    <Grid item xs={12} sx={{ display: { xs: 'none', sm: 'block' } }}>
      <HeadlineStorySkeleton />
    </Grid>
    <Grid item xs={12} sx={{ display: { xs: 'block', sm: 'none' } }} className='w-100'>
      <StorySkeleton />
    </Grid>
    {range(0, 8).map((i) => (
      <Grid key={i} item xs={12} sm={6} md={4} lg={4}>
        <StorySkeleton />
      </Grid>
    ))}
    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ display: { xs: 'block', sm: 'none', md: 'block' } }}>
      <StorySkeleton />
    </Grid>
  </Grid>
)

const HeadlineSkeletonText = () => (<Skeleton animation='wave' classes={{ root: 'h3' }} />)

const StorySkeleton = () => (
  <div className='ca-grid-card pa6 bg-white'>
    <Grid container className='h-100'>
      <Grid item xs={12} className='w-100'>
        <TileSkeleton />
      </Grid>
      <Grid item xs={12} className='w-100' height={154}>
        <Skeleton
          variant='rect'
          animation='pulse'
          classes={{ root: 'bg-void-grey w-100 mv6' }}
          height={154}
        />
      </Grid>
      <Grid item xs={12} className='w-100'>
        <Skeleton classes={{ root: 'w-65' }} />
      </Grid>
    </Grid>
  </div>
)

const TileSkeleton = () => (
  <Grid container direction='column' justifyContent='space-between' className={cx('relative h-100')}>
    <Grid item className='max-w-100'>
      <Skeleton classes={{ root: 'w-65' }} />
      <ContentSkeleton />
    </Grid>
  </Grid>
)

const ContentSkeleton = () => (
  <div className='ca-content black ca-homepage'>
    <div className='b ca-tile-title'>
      {range(0, 6).map(i => <Skeleton variant='text' animation='wave' key={i} />)}
    </div>
  </div>
)

const HeadlineStorySkeleton = () => (
  <Grid container className='ca-grid-card pb0 pt6 pl6 pr0 bg-white'>
    <Grid item sm={6} md={4} className='h-100'>
      <Skeleton variant='text' classes={{ root: 'w-60' }} />
      {range(0, 7).map((i) => <HeadlineSkeletonText key={i} />)}
      <Skeleton variant='text' classes={{ root: 'w-60' }} />
    </Grid>
    <Grid item sm={6} md={8} className='h-100 pl6 pb8'>
      <Skeleton
        variant='rect'
        animation='pulse'
        classes={{ root: 'h-100 bg-void-grey' }}
      />
    </Grid>
  </Grid>
)

export const AnnouncementsSkeleton = ({ maxHeight }) => (
  <div className='bg-twilight-grey relative'>
    <div style={{ maxHeight }}>
      <div className='announcements-content pa6 f4' style={{ overflow: 'hidden' }}>
        {range(0, 20).map(i => <Skeleton key={i} variant='text' animation='wave' />)}
      </div>
    </div>
  </div>
)
